import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {TagItem} from '../../models/tag-item.model';
import {Utilities} from '../../utilities/utilities.model';

@Component({
	selector: '[amd-tag-item]',
	templateUrl: './tag-item.component.html',
    styleUrls: ['./tag-item.component.scss']
})
export class TagItemComponent implements OnInit {
	static STATE_BASE = 'STATE_BASE';
	static STATE_EDIT = 'STATE_EDIT';

	stateBase = TagItemComponent.STATE_BASE;
	stateEdit = TagItemComponent.STATE_EDIT;

	@Input() item: TagItem;
	@Input() state: string;
	@Output() onClickDeleteEventEmitter: EventEmitter<TagItem> = new EventEmitter<TagItem>();
	@Output() onBlurEventEmitter: EventEmitter<TagItem> = new EventEmitter<TagItem>();
	@Output() onClickTagEventEmitter: EventEmitter<TagItem> = new EventEmitter<TagItem>();

	constructor() {
	}

	ngOnInit() {
	}

	onBlur(event: any) {
		if (!Utilities.isVoid(this.item.newLabel) && this.item.newLabel.length > 0
			&& (!Utilities.isVoid(this.item.label) || this.item.newLabel !== this.item.label)) {
			this.onBlurEventEmitter.emit(this.item);
		} else {
			this.item.newLabel = this.item.label;
		}
	}
}
